import type { LabelInValue, MedicalGroupList } from 'models';
import { useCallback } from 'react';

export const useMedicalGroupPickerCreateLabelInValueOption = () =>
  useCallback(
    (option: MedicalGroupList): LabelInValue => ({
      label: option.name,
      value: option.id,
    }),
    [],
  );
